import { SortValues } from '@/types/CarFilters.types';

import { FilterParams } from '../components/PlpFilters/PlpFilters.type';

export const getPlpSlug = (slug?: string[]): string => (slug ? slug.join('/') : 'used-cars');

export const PLP_BASE_PATH = '/used-cars';

export const camelToKebab = (str: string): string => {
  return str.replace(/([a-z0-9])([A-Z])/g, '$1-$2').toLowerCase();
};

export const kebabToCamel = (str: string): string => {
  return str.replace(/-([a-z])/g, (_, letter) => letter.toUpperCase());
};
export const isInvalidOrDefaultFilter = (filter?: string) => !filter || filter === '-';
const isInvalidOrDefaultSort = (sort?: string) =>
  !sort || sort === SortValues.Recommended || !Object.values(SortValues).includes(sort as SortValues);
export const isInvalidSort = (sort?: string) => !sort || !Object.values(SortValues).includes(sort as SortValues);
export const isEmptyOrDefaultFilter = (filter?: string) => !filter || filter === '-';
export const isInValidOrDefaultPage = (page?: string) => !page || isNaN(Number(page)) || Number(page) <= 1;
const returnSlugNullable = (name: string, value?: string) => ({
  name,
  value,
});

export const getPlpSlugFromParams = (params: FilterParams): string => {
  const { filter, sort, page } = params;

  const camelCaseSort = kebabToCamel(sort ?? '');

  const urlMap = new Map([
    ['filter', returnSlugNullable('filter', isEmptyOrDefaultFilter(filter) ? undefined : filter)],
    ['sort', returnSlugNullable('sort', isInvalidOrDefaultSort(camelCaseSort) ? undefined : sort)],
    ['page', returnSlugNullable('page', isInValidOrDefaultPage(page) ? undefined : page)],
  ]);
  const mapArray = Array.from(urlMap.values());
  const lastNonNullIndex = mapArray.findLastIndex((item) => item.value !== undefined);
  const trimmed = lastNonNullIndex !== -1 ? mapArray.slice(0, lastNonNullIndex + 1) : [];
  const result = trimmed.map((item) => {
    if (item.value === undefined) {
      switch (item.name) {
        case 'filter':
          return { name: item.name, value: '-' };
        case 'sort':
          return { name: item.name, value: SortValues.Recommended };
        case 'page':
          return { name: item.name, value: '1' };
      }
    }
    return item;
  });

  const joinedSlug = result.map((item) => item.value).join('/');
  return `${PLP_BASE_PATH}/${joinedSlug}`;
};
